import _get from 'lodash/get';
import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import Store from 'lightningjs-redux';
import { createItemAction } from '../cta/cta.actions';
import { getLayoutTheme } from '../tornado/utils/theme';
import { BrandIcon } from '../tornado/brand-icon/brandIcon.component';
import {
  getContentTemplateByTemplateId,
  getBlockTemplateById,
  getContentSizeByContentTemplateId,
} from '../tornado/templates';
import { calculateBlockHeight } from '../layout/abstractLayout.utils';
import { getTitle } from '../tornado/templates/blocks/utils/block';
import { track, trackImpressions, untrack } from '../tornado/utils/impression';
import { IMPRESSION_TRACK_SIGNAL, IMPRESSION_UNTRACK_SIGNAL, SELECTED_SIGNAL } from '../tornado/signals';
import { EXIT_APP_SIGNAL, HIDE_POPUP_SIGNAL } from '../popupContainer/popupContainer.constants';
import { ExitPopup } from '../popups/exitPopup/exitPopup.component';
import { getInitialStyle, getContentPadding, defaultContext, colors, WIDTH, CONTENT_GAP } from './profilesGate.style';

export class ProfilesGate extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Background: {
          rect: true,
        },
        CustomerLogo: {
          type: BrandIcon,
        },
        Title: {},
        Blocks: {},
        ExitPopup: {
          visible: false,
          type: ExitPopup,
          signals: {
            [EXIT_APP_SIGNAL]: '_handleExitAppSignal',
            [HIDE_POPUP_SIGNAL]: '_handleHidePopupSignal',
          },
          passSignals: {
            [EXIT_APP_SIGNAL]: false,
            [HIDE_POPUP_SIGNAL]: false,
          },
        },
        testId: 'ProfilesGate',
      },
      getInitialStyle(),
    );
  }

  _construct() {
    this._style = defaultContext;
  }

  _inactive() {
    // TODO: figure out if we actually want to track profiles
    trackImpressions(this._data);
  }

  set data(value) {
    this._data = value;

    const { blocks, layout } = this._data;
    if (!blocks || !blocks.length) {
      return;
    }

    const children = [];
    const theme = getLayoutTheme(_get(layout, 'theme'));
    const data = blocks[0];
    const title = getTitle(data.title);
    // The title comes from Phrase
    data.title = {};
    // Define Lightning classes that would be used to instantiate block and item views
    const blockType = getBlockTemplateById(data.blockTemplateId);
    const itemType = getContentTemplateByTemplateId(data.content.contentTemplateId);

    const itemSize = getContentSizeByContentTemplateId(data.content.contentTemplateId);
    const blockSize = calculateBlockHeight({ blockType, data, itemSize });
    const w = WIDTH[this._style.screenSize];

    children.push({
      type: blockType,
      data: {
        block: data,
        itemSize,
        itemType,
        theme,
        rowSize: {
          w,
          h: blockSize.h,
        },
      },
      contentGap: CONTENT_GAP[this._style.screenSize],
      contentPadding: getContentPadding(),
      w,
      h: blockSize.h,
      signals: {
        [SELECTED_SIGNAL]: '_handleSelected',
        [IMPRESSION_TRACK_SIGNAL]: '_impressionTrack',
        [IMPRESSION_UNTRACK_SIGNAL]: '_impressionUnTrack',
      },
    });

    this.patch({
      alpha: 1,
      Background: {
        color: theme.backgroundColor || colors.background[this._style.colorMode],
      },
      Title: {
        text: {
          text: title,
        },
      },
      Blocks: {
        children,
      },
    });

    this._refocus();
  }

  _getFocused() {
    return this.tag('ExitPopup').visible ? this.tag('ExitPopup') : this.tag('Blocks').children[0];
  }

  _handleSelected(item) {
    this.visible = false;

    return Store.dispatch(createItemAction({ item }));
  }

  _handleBack() {
    const exitPopup = this.tag('ExitPopup');
    exitPopup.visible = !exitPopup.visible;

    return true;
  }

  _handleExitAppSignal() {
    this.signal(EXIT_APP_SIGNAL);
  }

  _handleHidePopupSignal() {
    this.tag('ExitPopup').visible = false;
    this._refocus();
  }

  _impressionTrack(_, items) {
    track(0, items);
  }

  _impressionUnTrack(_, items) {
    untrack(0, items);
  }
}
